export const defaultCatalogLanguage = 'en'

export const supportedCatalogLanguages = ['en', 'fr', 'de']

export const isSupportedCatalogLanguage = (language) =>
  supportedCatalogLanguages.includes(String(language || '').toLowerCase())

export const normalizeCatalogLanguage = (language) => {
  const normalizedLanguage = String(language || '').toLowerCase()

  return isSupportedCatalogLanguage(normalizedLanguage)
    ? normalizedLanguage
    : defaultCatalogLanguage
}
